module.exports = __webpack_public_path__ + "img/bgimg.010470e5.jpg";